import React from 'react';
import { Alert } from '@patternfly/react-core';
import { observer } from 'mobx-react';
import { withErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { handleError } from 'services/ErrorService';
import OfferingCardBuilder from 'components/OfferingCardBuilder';
import { ModalityExtension } from 'types';
import { SkillsAssessment } from 'services/SkillsAssessmentService';

const ErrorMessage = () => {
  const { t } = useTranslation();

  return (
    <Alert
      variant="danger"
      isInline
      title={t("Oops! We're having trouble displaying this card.")}
    />
  );
};

type SkillsAssessmentCardProps = SkillsAssessment;

const computeTotalScore = (scores: SkillsAssessment['score']): number => {
  const totalPoints = scores.reduce((sum, s) => sum + s.points, 0);
  const totalMaximum = scores.reduce((sum, s) => sum + s.maximum, 0);
  if (totalMaximum === 0) return 0;
  return Math.round((totalPoints / totalMaximum) * 100);
};

const SkillsAssessmentCard = ({
  id,
  metadata,
  score,
  timestamp,
}: SkillsAssessmentCardProps) => (
  <OfferingCardBuilder
    entry={{
      modality: ModalityExtension.SkillsAssessment,
      id,
      title: metadata.assessment.name,
      timestamp,
      totalScore: computeTotalScore(score),
    }}
  >
    <OfferingCardBuilder.Header />
    <OfferingCardBuilder.Body />
    <OfferingCardBuilder.Footer skillsAssessmentId={id} />
  </OfferingCardBuilder>
);

export default withErrorBoundary(
  observer(SkillsAssessmentCard),
  ErrorMessage,
  handleError,
);
